export const getStringByCondition = (condition: unknown, trueValue: string, falseValue: string = ''): string => {
  return condition ? trueValue : falseValue;
};
